import { install } from 'resize-observer'

export default defineNuxtPlugin((_app) => {
  install()
})
